import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@hqo/ui-atoms';

interface CardCancelFooterProps {
  onCancel: () => void;
}

/** Footer for a cancellable upcoming visit: an inline "Cancel visit" action (opens the confirm modal). */
export const CardCancelFooter = ({ onCancel }: CardCancelFooterProps): JSX.Element => {
  const intl = useIntl();
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onCancel();
    },
    [onCancel],
  );

  return (
    <div className="mt-3 flex items-center justify-end border-t border-system-grey-light pt-3">
      <Button
        type="button"
        variant="outline"
        onClick={handleClick}
        data-testid="activity-card-cancel-visit"
        className="h-auto shrink-0 rounded-full px-[15px] py-2 text-[13px] font-semibold text-system-pink shadow-none hover:bg-system-grey-light hover:text-system-pink"
      >
        {intl.formatMessage({ id: 'activity.action.cancel' })}
      </Button>
    </div>
  );
};
